module.exports = __webpack_public_path__ + "img/all-zones-inactive.131c491e.svg";